import { render, staticRenderFns } from "./resume-invoice-modal.vue?vue&type=template&id=2fba3df0"
import script from "./resume-invoice-modal.vue?vue&type=script&lang=js"
export * from "./resume-invoice-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports